import { codes } from '@wix/wix-data-errors';
export default function platformizedCodeMapping(code) {
    if (code === 'WDE0020') {
        return codes.ValidationError;
    }
    if (code === 'WDE0024') {
        return codes.ValidationError;
    }
    if (code === 'WDE0025') {
        return codes.SchemaDoesNotExist;
    }
    if (code === 'WDE0026') {
        return codes.CollectionDeleted;
    }
    if (code === 'WDE0027') {
        return codes.PermissionDenied;
    }
    if (code === 'WDE0052') {
        return codes.SiteInTemplateMode;
    }
    if (code === 'WDE0073') {
        return codes.ItemDoesNotExist;
    }
    if (code === 'WDE0074') {
        return codes.ItemAlreadyExists;
    }
    if (code === 'WDE0022') {
        return codes.ValidationError;
    }
    if (code === 'WDE0007') {
        return codes.ValidationError;
    }
    return code;
}
//# sourceMappingURL=platformized-code-mapping.js.map